import { useQueryClient } from "@tanstack/react-query";
import { useClub } from "../../app/club";
import { useApi } from "../../app/services";

/** Every query key starts with the club slug and "comms" so one club's data is never shown for another. */
export function useScope() {
  const api = useApi();
  const queryClient = useQueryClient();
  const slug = useClub().club.slug;
  return { api, queryClient, slug };
}
